import {
  externalAssistantApi,
  externalSetupUtilityApi,
  externalWorkerApi,
} from '~/utils/api/external';

export const getSetupUtilityWin = async () => externalSetupUtilityApi.get<string>('/latest.yml');

export const getSetupUtilityMac = async () =>
  externalSetupUtilityApi.get<string>('/latest-mac.yml');

export const getSetupUtilityLinux = async () =>
  externalSetupUtilityApi.get<string>('/latest-linux.yml');

export const getWorkerWin = async () => externalWorkerApi.get<string>('/latest.yml');

export const getWorkerMac = async () => externalWorkerApi.get<string>('/latest-mac.yml');

export const getWorkerLinux = async () => externalWorkerApi.get<string>('/latest-linux.yml');

export const getAssistantWin = async () => externalAssistantApi.get<string>('/latest.yml');

export const getAssistantMac = async () => externalAssistantApi.get<string>('/latest-mac.yml');

export const getAssistantLinux = async () => externalAssistantApi.get<string>('/latest-linux.yml');
